import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ie-warning-modal',
  template: require('./ie-warning-modal.component.html')
})
export class IeWarningModalComponent {
  constructor(private activeModalService: NgbActiveModal) {}

  closeModal() {
    this.activeModalService.close();
  }
}
